import { render } from "./ContentHolder.vue?vue&type=template&id=6f30608c"
import script from "./ContentHolder.vue?vue&type=script&lang=js"
export * from "./ContentHolder.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__